import { render, staticRenderFns } from "./CompanyEditContactPartner.vue?vue&type=template&id=31153dc1&scoped=true&"
import script from "./CompanyEditContactPartner.vue?vue&type=script&lang=js&"
export * from "./CompanyEditContactPartner.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEditContactPartner.vue?vue&type=style&index=0&id=31153dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31153dc1",
  null
  
)

export default component.exports